"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFormChroot = void 0;
const definitions_1 = require("./definitions");
const chroot_1 = require("../ui-core/chroot");
/** 用于改变后续 DataFormField 在未指定 parentStub 时，默认的 parentStub */
const DataFormChroot = ({
    name: 'data-form-chroot',
    props: {
        // 参考 ui-core/chroot.ts DataFormChrootProps
        path: { type: String, default: "" },
        absolute: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        forceStub: { type: Object, default: null }, // 【不常用】强行指定使用这个 DataStub，忽略 path、readonly 等设置
    },
    computed: {
        chrootContext() {
            var _a, _b;
            const context = this[definitions_1.$formContext]();
            const parentChroot = (_a = this[definitions_1.$chrootContext]) === null || _a === void 0 ? void 0 : _a.call(this);
            const { path, absolute, readonly, forceStub } = this;
            const stub = forceStub || ((_b = ((!absolute && (parentChroot === null || parentChroot === void 0 ? void 0 : parentChroot.stub)) || (context === null || context === void 0 ? void 0 : context.rootStub))) === null || _b === void 0 ? void 0 : _b.getStubAtPath(path || ''));
            return new chroot_1.ChrootContext({
                stub,
                parentChroot: absolute ? null : parentChroot,
                readonly,
            });
        }
    },
    inject: {
        [definitions_1.$formContext]: { default: null },
        [definitions_1.$chrootContext]: { default: null },
    },
    provide() {
        return {
            [definitions_1.$chrootContext]: () => this.chrootContext,
        };
    },
    render(h) {
        const children = this.$slots.default;
        if (!(children === null || children === void 0 ? void 0 : children.length))
            return h();
        if (children.length > 1)
            throw new Error('DataFormChroot only support one child');
        return children[0];
    }
});
exports.DataFormChroot = DataFormChroot;
exports.default = DataFormChroot;
//# sourceMappingURL=DataFormChroot.js.map